import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';
import withAnimation from '../../../../shared/components/utils/hoc/withAnimation';

const MosaicCardContainer = styled.div<{ show: boolean }>`
  border: ${4 * Screen.widthRatio}px solid transparent;
  border-radius: ${20 * Screen.widthRatio}px;
  cursor: pointer;
  float: left;
  height: ${197 * Screen.widthRatio}px;
  margin-bottom: ${8 * Screen.widthRatio}px;
  opacity: ${(props) => (props.show ? 1 : 0)};
  position: relative;
  width: ${350 * Screen.widthRatio}px;
  &:hover {
    border: ${4 * Screen.widthRatio}px solid white;
  }
`;

export default withAnimation(MosaicCardContainer);
